export const DESIGN_W = 1536;
export const DESIGN_H = 1024;

export const GOLD = '#F5C542';

export const STAGE_LAYOUTS = {
  blue: {
    image: '/stages/blue.webp',
    wheel: { cx: 708, cy: 629, d: 204 },
    boxes: [
      { x: 846, y: 554, w: 73, h: 161 },
      { x: 927, y: 554, w: 74, h: 161 },
      { x: 1009, y: 554, w: 75, h: 161 },
      { x: 1092, y: 554, w: 73, h: 161 },
      { x: 1173, y: 554, w: 73, h: 161 },
    ],
    drawTimeBaked: false,
    liveDot: { cx: 1292, cy: 101, r: 10 },
    bottomCircle: { cx: 83, cy: 906, d: 132 },
  },
  red: {
    image: '/stages/red.webp',
    wheel: { cx: 694, cy: 617, d: 211 },
    boxes: [
      { x: 837, y: 534, w: 80, h: 172 },
      { x: 924, y: 534, w: 77, h: 172 },
      { x: 1008, y: 534, w: 77, h: 172 },
      { x: 1093, y: 534, w: 77, h: 172 },
      { x: 1177, y: 534, w: 77, h: 172 },
    ],
    drawTimeBaked: false,
    liveDot: { cx: 1277, cy: 96, r: 12 },
    bottomCircle: { cx: 83, cy: 854, d: 132 },
  },
  green: {
    image: '/stages/green.webp',
    wheel: { cx: 720, cy: 634, d: 204 },
    boxes: [
      { x: 860, y: 553, w: 76, h: 166 },
      { x: 943, y: 553, w: 74, h: 166 },
      { x: 1025, y: 553, w: 75, h: 166 },
      { x: 1108, y: 553, w: 74, h: 166 },
      { x: 1190, y: 553, w: 74, h: 166 },
    ],
    drawTimeBaked: true,
    liveDot: { cx: 1304, cy: 82, r: 8 },
    bottomCircle: { cx: 85, cy: 913, d: 135 },
  },
  purple: {
    image: '/stages/purple.webp',
    wheel: { cx: 717, cy: 626, d: 198 },
    boxes: [
      { x: 853, y: 551, w: 73, h: 159 },
      { x: 933, y: 551, w: 73, h: 159 },
      { x: 1013, y: 551, w: 73, h: 159 },
      { x: 1093, y: 551, w: 74, h: 159 },
      { x: 1174, y: 551, w: 75, h: 159 },
    ],
    drawTimeBaked: true,
    liveDot: { cx: 1286, cy: 101, r: 10 },
    bottomCircle: { cx: 85, cy: 908, d: 135 },
  },
};

export const OVERLAYS = {
  banner: { x: 250, y: 202, w: 1030, h: 72 },
  sidePlate: { x: 28, y: 295, w: 96, h: 530 },
  bottomCircle: { x: 28, y: 840, w: 116, h: 116 },
  datePlate: { x: 195, y: 946, w: 510, h: 64 },
  timePlate: { x: 745, y: 946, w: 500, h: 64 },
};

export const SHOW_SHORT = {
  '11am': '11 AM',
  '12pm': '12 PM',
  '5pm': '5 PM',
  '7pm': '7 PM',
};

const EASE_A = 0.45;
const EASE_S = 0.831;
const EASE_N = 6;
export const spinEase = (t) => {
  if (t <= EASE_A) return (EASE_S / EASE_A) * t;
  const u = (t - EASE_A) / (1 - EASE_A);
  return EASE_S + (1 - EASE_S) * (1 - Math.pow(1 - u, EASE_N));
};

export const makeSpinEase = (duration, w, lambda = 5) => {
  const a = (duration - w) / duration;
  const eL = Math.exp(-lambda);
  const F1 = ((1 - eL) / lambda - eL) / (1 - eL);
  const v0 = 1 / (a + (1 - a) * F1);
  return (t) => {
    if (t <= a) return v0 * t;
    const u = (t - a) / (1 - a);
    const F = ((1 - Math.exp(-lambda * u)) / lambda - u * eL) / (1 - eL);
    return v0 * (a + (1 - a) * F);
  };
};

const _eL = Math.exp(-5);
export const SPIN_TAIL = ((1 - _eL) / 5 - _eL) / (1 - _eL);

export const makeReelEase = (duration, w = 4, n = 3) => {
  const a = (duration - w) / duration;
  const s = (n * a) / (n * a + (1 - a));
  return (t) => {
    if (t <= a) return (s / a) * t;
    const u = (t - a) / (1 - a);
    return s + (1 - s) * (1 - Math.pow(1 - u, n));
  };
};
